import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild, inject, input, signal } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams } from '@camelot/menu';
import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent, ButtonSize, LayoutFullPanelComponent } from '@camelot/ui';

import { CamTranslationGrid } from '../../../translation.service';
import { AbstractGridComponent } from '../../abstract-grid.component';
import { FieldsSelectionComponent } from '../fields-selection.component';

@Component({
  imports: [ButtonComponent, CommonModule, FieldsSelectionComponent, LayoutFullPanelComponent, TranslatePipe],
  selector: 'cam-fields-selection-displayer',
  templateUrl: './fields-selection-displayer.component.html',
})
export class FieldsSelectionDisplayerComponent extends AbstractGridComponent<any> {
  label = input<string>();

  size = input<ButtonSize>('md');

  @ViewChild('template', { read: TemplateRef })
  template!: TemplateRef<void>;

  public isOpen = signal(false);

  private readonly _bottomSheet = inject(MatBottomSheet);

  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }

  public close() {
    this.isOpen.set(false);
    if (this.breakpoints.isMobile) {
      this._bottomSheet.dismiss();
    }
  }
  public open() {
    this.isOpen.set(true);
    if (this.breakpoints.isMobile) {
      this._bottomSheet.open<BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams<null>>(
        BottomSheetTemplateGenericComponent,
        {
          data: {
            context: null,
            template: this.template,
          },
          panelClass: 'no-padding',
        }
      );
    }
  }
}
